import axiosIntegration from "../Common/Axios/axiosIntegration";
import API from "../Common/Endpoint/serviceConstrants";

export const callActiveCardPostApi = async (payload) => {
  const { data = [] } = await axiosIntegration.post(API.switchAccountApi, payload);
  return data;
};
